import React, { useState, useEffect } from 'react';
import HttpServices from 'src/services/httpService';
import { integrateModuleURL } from 'src/services/urlService';
import LoadFacebookSdk from '../loadFacebookSdk';
import { useToaster } from 'src/utils/toaster/toasterContext';
import CustomDomainRedirectIframe from '../customDomainIframe';
import { CommonHelper } from 'src/utils/commonHelper';
import FacebookPageAuthorizationModal from '../facebookIntegration/facebookPageAuthorizationModal';
import { Config } from 'src/config';

const FacebookReAuthenticateAll = ({ handleClose, getConnectedNetworks }) => {
    const [isAuthorizationModalOpen, setAuthorizationModal] = useState(true);
    const [isLoadSdk, setLoadSdk] = useState(false);
    const { showToast } = useToaster();
    const isCustomDomain = CommonHelper.CustomDomain();
    let intervalId = null;
    let isProcessing = false;

    useEffect(() => {
        intervalId = setInterval(() => {
            checkAuthoCodeReceivedFromFacebook();
        }, Config.Common.socialAccountsIntegrationInterval);
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    const checkAuthoCodeReceivedFromFacebook = () => {
        if (isCustomDomain) {
            const handleMessage = (event) => {
                const { type, code } = event.data;
                if (type === 'fb_auth_code' && code && !isProcessing) {
                    isProcessing = true;
                    window.removeEventListener('message', handleMessage, false);
                    clearInterval(intervalId);
                    reAuthAllAccounts(code);
                }
            };
            window.addEventListener('message', handleMessage, false);
        } else {
            var code = localStorage.getItem('fb_autho_code');
            var error = localStorage.getItem('fb_error');
            if (code) {
                localStorage.removeItem('fb_autho_code');
                clearInterval(intervalId);
                reAuthAllAccounts(code);
            } else if (error) {
                localStorage.removeItem('fb_error');
                clearInterval(intervalId);
                showToast(error, 'e');
            }
        }
    };

    const reAuthAllSuccessCallback = (data, message) => {
        showToast(message, 's');
        getConnectedNetworks();
        handleClose();
    };

    const reAuthAllFailureCallback = (message) => {
        showToast(message, 'e');
        handleClose();
    };

    const reAuthAllAccounts = (code) => {
        let postProps = {
            url: integrateModuleURL.reAuthenticateAllFacebookAndInstagram,
            body: { code },
            successCallback: reAuthAllSuccessCallback,
            failureCallback: reAuthAllFailureCallback,
        };
        HttpServices.Post(postProps);
    };

    const handleConnectFacebook = () => {
        setLoadSdk(true);
    };

    return (
        <>
            {isAuthorizationModalOpen && (
                <FacebookPageAuthorizationModal
                    handleConnectFacebook={handleConnectFacebook}
                    handleClose={handleClose}
                    reAuth={true}
                />
            )}
            {isLoadSdk && <LoadFacebookSdk reauthenticate={false} />}
            {isCustomDomain && <CustomDomainRedirectIframe serviceName="facebook" />}
        </>
    );
};

export default FacebookReAuthenticateAll;